<template>
	<slot />
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

provide('isFdl', route.meta.embedded ?? false)
</script>
